import PropTypes from 'prop-types';

export const SiteCollectionResource = {
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    slugUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    current_status: PropTypes.string,
    owner: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        username: PropTypes.string.isRequired,
    }),
    category_ids: PropTypes.array.isRequired,
    hazard_ids: PropTypes.array,
};
